import Brand from "../components/Brand";
import Home from "../components/Home";
import Payment from "../components/Payment";

const HomePage = () => {
    return <>
        <Home />
        <Brand />
        <Payment />
    </>
}

export default HomePage;